import { FC } from 'react'
import { Typography } from '@material-tailwind/react'
import NoUploads from '../components/NoUploads'
import AgamiPreviewCard from '../ViewDashboard/AgamiPreviewCard'
import { ProposalActions, ProposalContext } from '../components/ProposalModeration'
import { AgamiSpot } from '../types/supabase'

interface ExperienceSpotsCardsProps {
  agamiListLoading: boolean
  agamiList: AgamiSpot[]
  removeFromExperience: (agami: AgamiSpot) => void
  showQrCode?: boolean
  /** Whether the caller holds `moderate` (05.4): without it the actions are ABSENT, not disabled. */
  canModerate?: boolean
  onRejectProposal?: (agami: AgamiSpot) => void
}

export const ExperienceSpotsCards: FC<ExperienceSpotsCardsProps> = ({
  agamiListLoading,
  agamiList,
  removeFromExperience,
  showQrCode,
  canModerate,
  onRejectProposal,
}) => (
  <div className="grid grid-cols-1 md:grid-cols-2 gap-4 py-2 items-stretch">
    {!agamiListLoading && (!agamiList || agamiList.length === 0) && (
      <div className="col-span-2">
        <NoUploads>
          <Typography>
            There are no <em>agamis</em> in this experience yet.
          </Typography>
        </NoUploads>
      </div>
    )}

    {!agamiListLoading &&
      agamiList?.map((agami) => (
        <div key={agami.id} className="h-full flex flex-col" data-testclass="agami-card-wrapper">
          <div className="grow">
            <AgamiPreviewCard
              userId={null}
              spot={agami}
              // A proposal is not "removed from the experience": rejecting it is
              // the one path out (05.4), so the card's remove button goes away.
              removeFromExperience={agami.proposal ? undefined : () => removeFromExperience(agami)}
              refetchAgamiList={() => {}}
              showQrCode={showQrCode}
            />
          </div>
          {agami.proposal && (
            <div
              className="flex items-center justify-between gap-2 flex-wrap px-2 py-1"
              data-testclass="proposal-moderation-bar"
            >
              <ProposalContext proposal={agami.proposal} />
              {canModerate && onRejectProposal && (
                <ProposalActions spot={agami} onReject={onRejectProposal} />
              )}
            </div>
          )}
        </div>
      ))}
  </div>
)
